import { TextField, Grid, Typography, MenuItem } from "@mui/material";
import { useFormContext, Controller } from "react-hook-form";
import MitarbeiterTags from "../MitarbeiterTags";

export default function IKSForm() {
  const { control } = useFormContext();

  const intervalloptionen = [
    "fallweise",
    "wöchentlich",
    "monatlich",
    "jährlich",
    "nach Erstellung des Jahresabschlusses",
    "nach Ende der Aufbewahrungsfrist"
  ];

  return (
    <Grid container spacing={3} direction="column">
         <Typography variant="h4" sx={{ fontWeight: 600, mb: 3 }}>
         Kontrollen und Datenschutzmaßnahmen in der Belegablage
                    </Typography>
      {/* Einleitung */}
      <Grid item xs={12}>
        <Typography variant="body1" gutterBottom>
          In diesem Abschnitt dokumentieren Sie die organisatorischen Maßnahmen zur regelmäßigen Kontrolle
          der Belegablage, Archivierung und Vernichtung. Ziel ist es, die Ordnungsmäßigkeit der Verfahren sicherzustellen
          und gesetzliche Vorgaben einzuhalten. Bitte geben Sie die Verantwortlichen für jede Kontrolle sowie das jeweilige Kontrollintervall an.
          Zusätzlich können Sie bestehende Datenschutzmaßnahmen beschreiben.
        </Typography>
      </Grid>

      {/* Kontrolle Entgegennahme */}
      <Grid item xs={12}>
        <Typography variant="subtitle2" gutterBottom>
          Verantwortlicher für die Kontrolle von Entgegennahme, Identifikation und Ablage
        </Typography>
        <Typography variant="body2" gutterBottom>
          Geben Sie hier den Namen des Mitarbeiters oder der Organisationseinheit ein, die für die Kontrolle der Entgegennahme,
          Identifikation und Ablage von Belegen zuständig ist (z. B. „Max Mustermann, Personalnummer 123" oder „Abteilung Buchhaltung").
        </Typography>
        <MitarbeiterTags 
          fieldName="kontrolleEntgegennahmeName"
          label="Verantwortlicher für die Kontrolle von Entgegennahme, Identifikation und Ablage"
          helperText="Klicken Sie auf einen Mitarbeiter-Tag, um ihn hinzuzufügen oder zu entfernen. Sie können auch manuell Text eingeben."
        />
        <Controller
          name="kontrolleEntgegennahmeName"
          control={control}
          render={({ field }) => (
            <TextField {...field} label="Verantwortlicher Entgegennahme/Identifikation/Ablage" fullWidth />
          )}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="subtitle2" gutterBottom>
          Intervall der Kontrolle für Entgegennahme/Identifikation/Ablage
        </Typography>
        <Typography variant="body2" gutterBottom>
          Wählen Sie hier das Zeitintervall aus, in dem die Kontrolle der Entgegennahme, Identifikation und Ablage durchgeführt wird.
        </Typography>
        <Controller
          name="kontrolleEntgegennahmeIntervall"
          control={control}
          render={({ field }) => (
            <TextField {...field} label="Kontrollintervall Entgegennahme" select fullWidth>
              {intervalloptionen.map((option) => (
                <MenuItem key={option} value={option}>{option}</MenuItem>
              ))}
            </TextField>
          )}
        />
      </Grid>

      {/* Kontrolle Archivierung */}
      <Grid item xs={12}>
        <Typography variant="subtitle2" gutterBottom>
          Verantwortlicher für die Kontrolle der Archivierung/Lesbarkeit
        </Typography>
        <Typography variant="body2" gutterBottom>
          Geben Sie hier den Namen des Mitarbeiters oder der Organisationseinheit ein, die für die Kontrolle der Archivierung
          und die Sicherstellung der Lesbarkeit zuständig ist.
        </Typography>
        <MitarbeiterTags 
          fieldName="kontrolleArchivierungName"
          label="Verantwortlicher für die Kontrolle der Archivierung/Lesbarkeit"
          helperText="Klicken Sie auf einen Mitarbeiter-Tag, um ihn hinzuzufügen oder zu entfernen. Sie können auch manuell Text eingeben."
        />
        <Controller
          name="kontrolleArchivierungName"
          control={control}
          render={({ field }) => (
            <TextField {...field} label="Verantwortlicher Archivierung/Lesbarkeit" fullWidth />
          )}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="subtitle2" gutterBottom>
          Intervall der Kontrolle für Archivierung/Lesbarkeit
        </Typography>
        <Typography variant="body2" gutterBottom>
          Wählen Sie hier das Zeitintervall aus, in dem die Kontrolle der Archivierung durchgeführt wird.
        </Typography>
        <Controller
          name="kontrolleArchivierungIntervall"
          control={control}
          render={({ field }) => (
            <TextField {...field} label="Kontrollintervall Archivierung" select fullWidth>
              {intervalloptionen.map((option) => (
                <MenuItem key={option} value={option}>{option}</MenuItem>
              ))}
            </TextField>
          )}
        />
      </Grid>

      {/* Kontrolle Vernichtung */}
      <Grid item xs={12}>
        <Typography variant="subtitle2" gutterBottom>
          Verantwortlicher für die Kontrolle der Vernichtung (Papier/Digital)
        </Typography>
        <Typography variant="body2" gutterBottom>
          Geben Sie hier den Namen des Mitarbeiters oder der Organisationseinheit ein, die für die Kontrolle der Vernichtung von Papier- und/oder digitalen Belegen zuständig ist.
        </Typography>
        <MitarbeiterTags 
          fieldName="kontrolleVernichtungName"
          label="Verantwortlicher für die Kontrolle der Vernichtung (Papier/Digital)"
          helperText="Klicken Sie auf einen Mitarbeiter-Tag, um ihn hinzuzufügen oder zu entfernen. Sie können auch manuell Text eingeben."
        />
        <Controller
          name="kontrolleVernichtungName"
          control={control}
          render={({ field }) => (
            <TextField {...field} label="Verantwortlicher Vernichtung" fullWidth />
          )}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="subtitle2" gutterBottom>
          Intervall der Kontrolle für Vernichtung
        </Typography>
        <Typography variant="body2" gutterBottom>
          Wählen Sie hier das Intervall, in dem die Kontrolle der Vernichtung von Papier- oder digitalen Belegen durchgeführt wird
          (z. B. nach Erstellung des Jahresabschlusses oder nach Ende der Aufbewahrungsfrist).
        </Typography>
        <Controller
          name="kontrolleVernichtungIntervall"
          control={control}
          render={({ field }) => (
            <TextField {...field} label="Kontrollintervall Vernichtung" select fullWidth>
              {intervalloptionen.map((option) => (
                <MenuItem key={option} value={option}>{option}</MenuItem>
              ))}
            </TextField>
          )}
        />
      </Grid>

      {/* Datenschutzmaßnahmen */}
      <Grid item xs={12}>
        <Typography variant="subtitle2" gutterBottom>
          Datenschutzmaßnahmen
        </Typography>
        <Typography variant="body2" gutterBottom>
          Beschreiben Sie hier alle bestehenden Datenschutzmaßnahmen, die im Zusammenhang mit den Prozessen zur Belegablage stehen.
          Dazu zählen z. B. Zugangskontrollen, Protokollierungen, technische Sicherungsmaßnahmen oder organisatorische Maßnahmen.
        </Typography>
        <Controller
          name="datenschutzMassnahmen"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              label="Datenschutzmaßnahmen (z. B. Zugangskontrolle, Protokolle)"
              multiline
              rows={4}
              fullWidth
            />
          )}
        />
      </Grid>
    </Grid>
  );
}